import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-571180da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "VarietiesTreeSelector" }
const _hoisted_2 = { class: "variety" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "variety__title" }, "热门", -1))
const _hoisted_4 = { class: "variety__list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "variety__title" }, "种类", -1))
const _hoisted_7 = { class: "variety__list" }
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanList = _resolveComponent("VanList")!
  const _component_VanTreeSelect = _resolveComponent("VanTreeSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VanTreeSelect, {
      items: $setup.list,
      onClickNav: $setup.clickNav,
      "main-active-index": $setup.activeIndex,
      "onUpdate:main-active-index": _cache[1] || (_cache[1] = ($event: any) => (($setup.activeIndex) = $event))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.hotList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "variety__list-item",
                key: index,
                onClick: ($event: any) => ($setup.confirm(item.id,item.name))
              }, _toDisplayString(item.name), 9, _hoisted_5))
            }), 128))
          ])
        ]),
        ($setup.list[$setup.activeIndex]?.children)
          ? (_openBlock(), _createBlock(_component_VanList, {
              key: 0,
              class: "variety",
              onLoad: $setup.searchVarietis,
              loading: $setup.loading,
              finished: $setup.finished,
              "immediate-check": false
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", {
                    class: "variety__list-item",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.confirm("")))
                  }, "全部"),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list[$setup.activeIndex].children, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "variety__list-item",
                      key: index,
                      onClick: ($event: any) => ($setup.confirm(item.key,item.value))
                    }, _toDisplayString(item.value), 9, _hoisted_8))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["loading", "finished"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["items", "main-active-index"])
  ]))
}